export default __webpack_public_path__ + "static/media/itemConsolidation.b09ee020.svg";